export const pluralize = (items: string[]): string => {
  if (items.length === 1) {
    return items[0];
  }
  if (items.length === 2) {
    return items.join(', and ');
  }
  const itemsClone = [...items];
  const finalTwoItems = [itemsClone[itemsClone.length - 2], itemsClone[itemsClone.length - 1]].join(', and');
  return [...itemsClone.slice(0, itemsClone.length - 3), finalTwoItems].join(', ');
};
